
import './App.css';
import AllRoutes from './Routes/AllRoutes.jsx';
import Navbar from './Routes/Navbar.jsx';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <AllRoutes/>
    </div>
  );
}

export default App;
